import {FC, ReactNode, useMemo} from 'react';

import {useTranslation} from 'react-i18next';

import {Box, Typography} from '@mui/material';

import {Editable} from './Editable';
import {greenColors} from '../../../../../layouts/theme/designSystem';
import {sortByYearDesc} from '../../../../../utils/dateUtils/sortEvents';
import * as Types from '../../types';

interface Props {
  onEdit?: (formType: Types.ProfileFormType, id?: string) => void;
  data: {
    education: Types.ProfileEducation[];
  };
}

const Education = ({onEdit, data}: Props) => {
  const {t} = useTranslation();
  const {t: td} = useTranslation('domain');
  const sortedEducations = useMemo(() => sortByYearDesc(data.education), [data.education]);
  const ExpItem = useMemo(() => {
    const EdItem: FC<{
      header: ReactNode;
    }> = (props) => {
      return <Box>{props.header}</Box>;
    };
    return EdItem;
  }, []);
  return (
    <Editable onAdd={() => onEdit?.('education')} testid='add-education'>
      <Typography variant='h2'>{t('applicantProfile.education.title')}</Typography>
      {sortedEducations.map((ed, idx) => (
        <Box
          sx={{
            mt: 3,
          }}
          key={ed.schoolName + idx}
        >
          <ExpItem
            header={
              <Editable
                onEdit={() => {
                  onEdit?.('education', ed.id);
                }}
                testid='edit-education'
                sx={{
                  mt: 0,
                }}
              >
                <Typography variant='h3' dangerouslySetInnerHTML={{__html: ed.schoolName}} />
                <Typography
                  variant='body1'
                  dangerouslySetInnerHTML={{
                    __html: [ed.fieldOfStudy, ed.degree ? td(`eductionDegreeEnum.${ed.degree}`) : '']
                      .filter((x) => x)
                      .join(', '),
                  }}
                />
                <Typography variant='body1' color={greenColors[70]}>
                  {ed.startYear} - {ed.endYear}
                </Typography>
              </Editable>
            }
          />
        </Box>
      ))}
    </Editable>
  );
};

export default Education;
